
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"2","width":"13","height":"16","rx":"1","fill":"#E345FF"}}),_c('rect',{attrs:{"x":"6","y":"4","width":"13","height":"16","rx":"1","fill":"#5935DD"}})])
          )
        }
      }
    